import { defineAction } from '_utils/redux'
import humps from 'humps'

import * as reportService from '_services/reports'
import { getToken } from '_/utils/token'
import { blobInstance } from '_/services/requests'

export const REPORT_LIST = defineAction('REPORT_LIST')
export const REPORT_BY_ID = defineAction('REPORT_BY_ID')
export const REPORTS_BY_FILTERS = defineAction('REPORTS_BY_FILTERS')
export const REPORTS_TO_DOWNLOAD = defineAction('REPORTS_TO_DOWNLOAD')

export const getReportsList = params => async (dispatch, getState) => {
  const data = await reportService.getReportsListService(getState().user.authToken)(
    humps.decamelizeKeys(params)
  )

  dispatch({
    type: REPORT_LIST.ACTION,
    payload: async () => data,
    meta: params,
  })

  return data
}

export const getReportById = reportId => async (dispatch, getState) => {
  const data = await reportService.getReportByIdService(getState().user.authToken)(reportId)

  dispatch({
    type: REPORT_BY_ID.ACTION,
    payload: async () => data,
  })

  return data
}

export const getReportsByFilters = (reportId, payload) => async (dispatch, getState) => {
  const data = await reportService.getReportsByFiltersService(getState().user.authToken)(
    reportId,
    payload
  )

  dispatch({
    type: REPORTS_BY_FILTERS.ACTION,
    payload: async () => data,
  })

  return data
}

export const getReportsToDownload = async (reportId, payload) => {
  const headers = getToken()

  return blobInstance.post(`/reports/${reportId}/export/`, humps.decamelizeKeys(payload), {
    ...headers,
    'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })
}
